

var _squid = require('squid');

var _index = require('xo-models/src/checkout/index');

require('xo-ui-components/src/error-tooltip/directive');

var _index2 = require('xo-models/src/user/index');

var _template = require('./template');

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

angular.module().directive('xoAddTaxId', function () {
    return {
        scope: {
            token: '=?',
            finish: '=?'
        },
        template: _template2['default'],

        controller: ['$scope', '$element', function ($scope, $element) {

            function thenFunction() {
                var taxIdType = 'CPF';

                if ($scope.checkoutSession.errorData && $scope.checkoutSession.errorData.cause === 'NEED_BUSINESS_TAX_INFO_TO_PAY') {
                    taxIdType = 'CNPJ';
                }
                var issuer = 'BR_' + taxIdType;

                $scope.subType = taxIdType;

                $scope.userInfo = _index2.$UserInfoModel.instance($scope.token);

                $scope.onSubmit = function () {
                    // Scrub the formatting when invoking the backend services.
                    var unformatted = ($scope.taxId || '').replace(/[^0-9]+/g, '');
                    var data = {
                        newDocId: {
                            type: 'TAX_ID',
                            subType: $scope.subType,
                            issuerCountry: 'BR',
                            issuer: issuer,
                            value: unformatted,
                            collectionPoint: 'UNKNOWN',
                            placeOfIssue: 'BR'
                        }
                    };

                    $scope.userInfo.action('addTaxId', {
                        data: data,

                        success: function success() {
                            var checkoutSession = _index.$CheckoutSessionModel.instance($scope.token);
                            var checkoutCart = _index.$CheckoutCartModel.instance($scope.token);

                            return checkoutSession.action('create', {
                                data: {
                                    baToken: checkoutCart.billing && checkoutCart.billing.ba_token
                                },
                                success: function success() {
                                    // Clear the errors if create checkout session was successful
                                    $scope.checkoutSession.errorData = undefined;
                                    $scope.finish();
                                }
                            });
                        },

                        validation: function validation(validationData) {
                            var $el = $($element);
                            var $field = $($el.find('[name="' + validationData.field + '"]'));

                            $field.addClass('backendError');
                            $field.attr('aria-invalid', true);
                            $field.focus();
                        }
                    });
                };

                $scope.changeTaxId = function (newValue) {
                    var unformatted = (newValue || '').replace(/[^0-9]+/g, '');
                    var formatted = '';
                    var i = 0;

                    // For CPF we will format the output with dots and dashes like this:
                    // 999.999.999-99
                    if ($scope.subType === 'CPF') {
                        for (i = 0; i < unformatted.length; i++) {
                            if (i === 3 || i === 6) {
                                formatted = formatted + '.';
                            }
                            if (i === 9) {
                                formatted = formatted + '-';
                            }
                            formatted = formatted + unformatted.charAt(i);
                        }
                        $scope.taxId = formatted;
                        // For CNPJ we will format the output with dots, dashes, and slashes like this:
                        // 99.999.999/9999-99
                    } else if ($scope.subType === 'CNPJ') {
                        for (i = 0; i < unformatted.length; i++) {
                            if (i === 2 || i === 5) {
                                formatted = formatted + '.';
                            } else if (i === 8) {
                                formatted = formatted + '/';
                            } else if (i === 12) {
                                formatted = formatted + '-';
                            }
                            formatted = formatted + unformatted.charAt(i);
                        }
                        $scope.taxId = formatted;
                    } else {
                        $scope.taxId = unformatted;
                    }
                };
            }

            (0, _squid.$populate)($scope, {
                checkoutSession: _index.$CheckoutSessionModel.instance($scope.token)
            }).then(thenFunction());
        }]
    };
});

_squid.$populate;

_index.$CheckoutCartModel;

_index.$CheckoutSessionModel;

_index2.$UserInfoModel;


//////////////////
// WEBPACK FOOTER
// ../node_modules/xo-form-components/src/add-tax-id/directive.js
// module id = ../node_modules/xo-form-components/src/add-tax-id/directive.js
// module chunks = 0